import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const AsyncSurveyDetails = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "async-survey" */ './Survey')),
});
